var map = {
	"./MyCard": 686,
	"./MyCard.js": 686,
	"./OrderDay": 2604,
	"./OrderDay.js": 2604,
	"./StoryStatistics": 2605,
	"./StoryStatistics.js": 2605
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4839;